import React from 'react';
import { FINANCE_CHARGE_BADGE_LABEL, isFinanceChargeInvoice } from '../pages/invoiceUi';

/** Small pill on finance-charge (late fee) invoices; renders nothing for others. */
export function FinanceChargeBadge({ invoice }: { invoice: { invoiceType?: string | null } }) {
  if (!isFinanceChargeInvoice(invoice)) return null;
  return (
    <span className="inline-flex items-center rounded-full bg-amber-50 px-2 py-0.5 text-xs font-semibold text-amber-800 whitespace-nowrap">
      {FINANCE_CHARGE_BADGE_LABEL}
    </span>
  );
}
